import React,{useEffect} from 'react'
import SidebarInf04 from '../components/sidebar/SidebarInf04'
import 'highlight.js/styles/atom-one-dark.css';
import hljs from 'highlight.js';




const Sidebarhelp04 = () => {

  useEffect(() => {
    hljs.addPlugin({
        'after:highlightElement': ({ result, el }) => {
            const lines = document.createElement('div');
            if (!result.value.includes('<span class="line-num">')) {
                lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
            }
            el.replaceChildren(...lines.childNodes);
        }
    });


    if (!document.querySelector('.hljs')) {
      hljs.highlightAll();
  }
   
  });


  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf04></SidebarInf04>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Materiały,wskazówki,pomoc do INF04</h1>
            <section>
              <hr></hr>
              <h2>Wprowadzenie</h2>
              <blockquote class="introduction">
                <strong>Hejj... hmm</strong>
               Na tej podstronie znajdziesz różnego rodzaju materiały przygotowane pod egzamin INF04!
               Znajdziesz je używając tego panelu na boku albo na górze w zależności jakie masz urządzenie.

              </blockquote>
              <hr></hr>
              <h2>Rzeczy które znajdziesz</h2>
              <ul>
                  <li>Rodzaje zadań</li>
                  <li>Wskazówki i Pomoc</li>
                  <li>Szybka Potwórka (w trakcie budowy)</li>
                  <li>Ustawienia (w trakcie budowy)</li>
                </ul>
              <hr></hr>
            </section>

                

<blockquote className="info">
    <strong>Informacja Globalna</strong>
    Strona jest ciągle rozwijana (jest opensource na githubie), więc mogę być błędy , a czasem także niedokończone rzeczy.
    Wybacz... Ale spokojnie wszystko się zrobi!
</blockquote>

          </div>
          
        </div>
    </div>
  )
}

export default Sidebarhelp04

